<template>
  <b-container>
    <b-row>
      <h1>Editar Formulários</h1>
      <success-fade-alert ref="alert" msg="Formulário editado com sucesso" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <base-error-container :modelstate="modelstate"></base-error-container>

    <b-row class="mb-3 ml-0">
      <router-link :to="'/checklist/layout/form/Own/'">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>

      <b-button size="sm" class="ml-2" @click="openStory()">
        Historico
      </b-button>

      <b-button size="sm" class="ml-2" @click="openPendingModal()">
        Campos com pendências
      </b-button>
    </b-row>

    <b-form-group
      label="Nome do formulário"
      label-for="input-form-name"
      class="mb-4"
    >
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="form.nome"
        required
        placeholder="Insira o nome do formulário"
      ></b-form-input>
      <span class="text-danger" v-if="modelstate['Nome']">
        {{ modelstate["Nome"][0] }}
      </span>
    </b-form-group>

    <div v-if="form != null && form.campos" class="mb-4">
      <table-form-fields
        ref="teste"
        :items="form.campos"
        :allow-add-fields="true"
        :company-options="companyOptions"
        :options-profiles="optionsProfiles"
        :profiles="profiles"
        :userMaster="userMaster"
      ></table-form-fields>
    </div>

    <!-- Search key -->
    <form-search-key
      v-if="form != null"
      :form="form"
      :modelstate="modelstate"
    ></form-search-key>

    <b-row>
      <b-col md="4">
        <b-form-group
          label-for="CanReopenForm"
          :label="$t('checklist.form.canReopenForm')"
          class="mb-4"
        >
          <b-form-select
            id="CanReopenForm"
            :options="optionsBoolean"
            v-model="form.canReopenForm"
          />

          <span class="text-danger" v-if="modelstate['CanReopenForm']">
            {{ modelstate["CanReopenForm"][0] }}
          </span>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group
          label-for="NotifyFill"
          :label="'Agrupar campos na exportação'"
          class="mb-4"
        >
          <b-form-select
            id="CanReopenForm"
            :options="optionsBoolean"
            v-model="form.groupEqualFields"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <!-- {{ form.notify }} -->
        <b-form-group
          label-for="NotifyFill"
          :label="'Notificar preenchimento'"
          class="mb-4"
        >
          <!-- <notify-fill-dropdown :model.sync="form.notify">
          </notify-fill-dropdown> -->
          <pendency-generation-notify-dropdown
            id="NotifyFill"
            class="select-boolean"
            :model.sync="form.notifyFill"
          >
          </pendency-generation-notify-dropdown>
          <span class="text-danger" v-if="modelstate['NotifyFill']">
            {{ modelstate["NotifyFill"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="form.notifyFill">
        <b-form-group
          label-for="NotifyFill"
          :label="'Tipo de anexo'"
          class="mb-4"
        >
          <pdf-attachment-mode
            :isForm="true"
            :model.sync="form.pdfAttachmentMode"
          ></pdf-attachment-mode>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesFill')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesFill"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesFill')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesFill"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesViewer')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesViewer"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesViewer')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesViewer"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesEdit')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesEditor"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesEdit')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesEdit"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.pendencyExpirationIntervalType')"
          label-for="PendencyExpirationIntervalType"
          class="mb-4"
        >
          <b-form-select
            id="PendencyExpirationIntervalType"
            :options="optionsIntervalType"
            v-model="form.pendencyExpirationIntervalType"
          ></b-form-select>
          <span
            class="text-danger"
            v-if="modelstate['PendencyExpirationIntervalType']"
          >
            {{ modelstate["PendencyExpirationIntervalType"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          v-if="canShowPendencyExpirationIntervalRange"
          :label="getPendencyExpirationIntervalRangeLabel"
          label-for="PendencyExpirationIntervalRange"
          class="mb-4"
        >
          <base-input-integer
            id="PendencyExpirationIntervalRange"
            placeholder="Insira o range da frequência"
            :value.sync="form.pendencyExpirationIntervalRange"
            :readonly="false"
          >
          </base-input-integer>
          <span
            class="text-danger"
            v-if="modelstate['PendencyExpirationIntervalRange']"
          >
            {{ modelstate["PendencyExpirationIntervalRange"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">
        <b-form-group
          label="Nível de compressão"
          label-for="CompressionLevel"
          v-if="companyHasIntegrations"
        >
          <b-form-input
            id="compressionLevel"
            v-model="form.compressionLevel"
            type="range"
            min="10"
            max="100"
          ></b-form-input>
          <span :style="typeColor()">
            {{ statusQuality() }}
          </span>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <!-- Qualidade da imagem -->
        <b-form-group
          label="Qualidade da imagem"
          label-for="imageQualityType"
          v-if="companyHasIntegrations"
        >
          <!-- Qualidade Padrão(480P) -->
          <b-form-checkbox
            id="imageQualityType"
            v-model="form.imageQualityType"
            :value="0"
            :unchecked-value="1"
          >
            480P
          </b-form-checkbox>
          <!-- Qualidade Alta(1080P) -->
          <b-form-checkbox
            class="mt-3"
            id="imageQualityType"
            v-model="form.imageQualityType"
            :value="1"
            :unchecked-value="0"
          >
            1080P
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="form.userMaster || companyHasIntegrations">
      <b-col md="12">
        <b-form-group
          :label="$t('checklist.form.ScriptPythonProcess')"
          label-for="ScriptPythonProcess"
        >
          <b-row v-if="form.userMaster">
            <b-col cols="4">
              <b-form-select
                id="geraAnomalia"
                class="select-boolean"
                :options="optionsScriptProcess"
                v-model="form.predefinedScriptProcess.predefinedScriptId"
              ></b-form-select>
            </b-col>
          </b-row>
          <div v-if="form.predefinedScriptProcess.predefinedScriptId != 0">
            <predefined-script-form
              :predefinedScriptId.sync="
                form.predefinedScriptProcess.predefinedScriptId
              "
              :script.sync="form.postCalculationScript"
              :fields.sync="form.campos"
              :model.sync="form.predefinedScriptProcess"
            ></predefined-script-form>
          </div>
          <custom-codemirror
            class="mt-4"
            :readonly="form.userMaster"
            id="ScriptPythonProcess"
            :model.sync="form.scriptPythonProcess"
          />

          <span class="text-danger" v-if="modelstate['ScriptPythonProcess']">
            {{ modelstate["ScriptPythonProcess"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="form.userMaster || companyHasIntegrations">
      <b-col md="12">
        <b-form-group
          :label="$t('checklist.form.scriptPythonValidatePendencies')"
          label-for="ScriptPythonValidatePendencies"
        >
          <b-row v-if="form.userMaster">
            <b-col cols="4">
              <b-form-select
                id="geraAnomalia"
                class="select-boolean"
                :options="optionsScriptValidatePendencies"
                v-model="
                  form.predefinedScriptValidationPendencies.predefinedScriptId
                "
              ></b-form-select>
            </b-col>
          </b-row>
          <div
            v-if="
              form.predefinedScriptValidationPendencies.predefinedScriptId != 0
            "
          >
            <predefined-script-form
              :predefinedScriptId.sync="
                form.predefinedScriptValidationPendencies.predefinedScriptId
              "
              :script.sync="form.scriptPythonValidatePendencies"
              :fields.sync="form.campos"
              :model.sync="form.predefinedScriptValidationPendencies"
            ></predefined-script-form>
          </div>
          <custom-codemirror
            class="mt-4"
            :readonly="form.userMaster"
            id="ScriptPythonValidatePendencies"
            :model.sync="form.scriptPythonValidatePendencies"
          />

          <span
            class="text-danger"
            v-if="modelstate['ScriptPythonValidatePendencies']"
          >
            {{ modelstate["ScriptPythonValidatePendencies"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <form-history :id="id" ref="story"></form-history>
    <b-row>
      <b-button size="sm" @click="saveEditions" :disabled="submitted">
        Salvar formulário
      </b-button>
    </b-row>

    <form-pending-modal
      ref="pendingModal"
      displayName="Pendências"
      :items="fieldsWithPendencie()"
      :company-options="companyOptions"
      :options-profiles="optionsProfiles"
      :profiles="profiles"
    />

    <!-- <pre class="language-json"><code>model: {{ form  }}</code></pre> -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseErrorContainer from "@/components_rms/base/BaseErrorContainer.vue";
import BaseInputInteger from "@/components_rms/base/BaseInputInteger.vue";
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";
import { all } from "axios";

export default {
  name: "EditForm",
  components: {
    BaseErrorContainer,
    BaseInputInteger,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    FormPendingModal: () =>
      import("@/components_rms/checklist/form/FormPendingModal.vue"),
    FormSearchKey: () =>
      import("@/components_rms/checklist/form/FormSearchKey.vue"),
    PendencyGenerationNotifyDropdown: () =>
      import(
        "@/components_rms/checklist/pendency/PendencyGenerationNotifyDropdown.vue"
      ),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TableFormFields: () =>
      import("@/components_rms/checklist/form/TableFormFields.vue"),
    FormHistory: () =>
      import("@/components_rms/checklist/form/FormHistory.vue"),
    PdfAttachmentMode: () =>
      import("@/components_rms/checklist/fill/PdfAttachmentMode.vue"),
    CustomCodemirror,
  },
  props: {
    id: String,
    readonly: Boolean,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: function () {
    return {
      alert: {
        error: "",
      },
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      companyOptions: [
        { value: null, text: "Tipo" },
        { value: 1, text: "Lógico" },
        { value: 2, text: "Data" },
        { value: 3, text: "Hora" },
        { value: 4, text: "Decimal" },
        { value: 5, text: "Inteiro" },
        { value: 6, text: "Texto" },
        { value: 7, text: "Lista" },
        { value: 8, text: "Anotação" },
        // { value: 9, text: "Apenas Anexos"}
      ],
      companyHasIntegrations: false,
      submitted: false,
      sucesso: false,
      modelstate: {},
      form: {},
      optionsProfiles: [],
      optionsIntervalType: [
        { value: 0, text: "Não expira" },
        { value: 1, text: "Hora" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
        { value: 5, text: "Ano" },
      ],
      profiles: [],
      profilesFill: [],
      profilesViewer: [],
      profilesEditor: [],
      userMaster: false,
      optionsScriptProcess: [],
      optionsScriptValidatePendencies: [],
    };
  },
  created: function () {
    this.loadCompanyOptions();
    this.loadCompanyHasIntegrations();
    this.loadCompanyProfiles();
    this.loadData();
    this.getScriptDropdown();
  },
  
  computed: {
    canShowPendencyExpirationIntervalRange() {
      if (this.form) {
        if (this.form.pendencyExpirationIntervalType > 0) {
          return true;
        }
      }
      return false;
    },
    getPendencyExpirationIntervalRangeLabel() {
      let text = this.$t("checklist.form.pendencyExpirationIntervalRange");
      if (this.form) {
        switch (this.form.pendencyExpirationIntervalType) {
          case 1:
            return `${text} (Horas)`;
          case 2:
            return `${text} (Dias)`;
          case 3:
            return `${text} (Semanas)`;
          case 4:
            return `${text} (Meses)`;
          case 5:
            return `${text} (Anos)`;
          default:
            return text;
        }
      }
      return text;
    },
  },
  methods: {
    fieldsWithPendencie() {
      if (this.form == null) {
        return [];
      }
      const allPendencies = this.getFieldWithPendency(this.form.campos);

      return allPendencies;
    },
    getFieldWithPendency(fields) {
      let allPendencies = [];

      for (let field of fields ?? []) {
        if (field.geraAnomalia == 2) {
          field.valor = "";
          allPendencies.push(field);
        }

        if (field.tipo == 7)
          for (let option of field.valores ?? []) {
            if (option.geraAnomalia == 2) {
              option.nome = field.nome;
              allPendencies.push(option);
            }
            let additionalFields = this.getFieldWithPendency(
              option.camposAdicionais
            );
            for (let additionalField of additionalFields ?? []) {
              allPendencies.push(additionalField);
            }
          }

        if (field.tipo == 13) {
          if (field.valores) {
            for (let option of field.valores ?? []) {
              if (option.geraAnomalia == 2) {
                option.nome = field.nome;
                allPendencies.push(option);
              }
              let additionalFields = this.getFieldWithPendency(
                option.camposAdicionais
              );
              if (additionalFields) {
                for (let additionalField of additionalFields) {
                  allPendencies.push(additionalField);
                }
              }
            }
          }
        }

        if (field.tipo == 22) {
          let subFields = this.getFieldWithPendency(field.subForm.fields);
          for (let subField of subFields ?? []) {
            allPendencies.push(subField);
          }
        }
      }
      return allPendencies;
    },
    getScriptDropdown() {
      this.$apiChecklist.get("/predefinedScript/getAllDropdown/").then((response) => {
        for (let script of response.data) {
          // console.log(script);
          let opt = { value: script.id, text: script.name };
          if (script.scriptType == 4) {
            optionsScriptValidatePendencies.push(opt);
          } else if (script.scriptType == 2) {
            this.optionsScriptProcess.push(opt);
          }
        }
      });
    },
    openStory() {
      this.$refs.story.openModal();
    },
    openPendingModal() {
      this.$refs.pendingModal.showModal();
    },
    loadCompanyOptions() {
      this.$apiChecklist
        .get("/systemFieldType/getCompanyTypes/")
        .then((response) => {
          this.companyOptions = response.data;
        });
    },
    loadCompanyHasIntegrations() {
      this.$apiChecklist
        .get("/systemIntegrationCompany/hasIntegrations/")
        .then((response) => {
          this.companyHasIntegrations = response.data.status == 2100;
        });
    },
    loadCompanyProfiles() {
      this.$apiScheduler
        .get("/profile/getCompanyProfiles/")
        .then((response) => {
          this.profiles = response.data.sort((a1, a2) =>
            a1.displayName.localeCompare(a2.displayName)
          );
          this.optionsProfiles = [{ value: null, text: "Selecione o perfil" }];
          this.profiles.forEach((x) => {
            this.optionsProfiles.push({
              value: x.id,
              text: x.displayName,
            });
          });
        });
    },
    async loadData() {
      this.$apiChecklist
        .get("/form/getdetailed/" + this.id.toString())
        .then((response) => {
          // console.log(response);
          // console.log(response.data);

          if (response.data.data == null) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.form = response.data.data;
            this.profilesFill = this.form.profilesFill;
            this.profilesViewer = this.form.profilesViewer;
            this.profilesEditor = this.form.profilesEditor;
            this.userMaster = this.form.userMaster;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          this.form = {};
          console.log("Error to load data on EditForm");
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    saveEditions() {
      this.submitted = true;
      this.form.pendencyExpirationIntervalRange = parseInt(
        this.form.pendencyExpirationIntervalRange
      );

      this.$apiChecklist
        .post("/form/Edit/" + this.id.toString(), this.form)
        .then((response) => {
          if (response.data.data == null) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.form = response.data.data;
            this.$refs.alert.show();
          }
          this.submitted = false;
          this.modelstate = {};
          window.scrollTo(0, 0);
          //console.log("Criou")
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText}`;
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            }
          } else {
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
    onChangeProfilesFill(value) {
      this.profilesFill = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesFill = this.profilesFill;
    },
    onChangeProfilesViewer(value) {
      this.profilesViewer = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesViewer = this.profilesViewer;
    },
    onChangeProfilesEdit(value) {
      this.profilesEditor = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesEditor = this.profilesEditor;
    },
    typeColor() {
      let compressionLevel = this.form.compressionLevel;
      if (this.$store.getters.darkmode == true) {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: lawngreen";
        }
      } else {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: green";
        }
      }
    },
    statusQuality() {
      let compressionLevel = this.form.compressionLevel;
      if (compressionLevel < 40) {
        return `${compressionLevel} Baixa qualidade`;
      } else if (compressionLevel >= 40 && compressionLevel <= 80) {
        return `${compressionLevel} Média Qualidade`;
      } else if (compressionLevel > 80) {
        return `${compressionLevel} Alta qualidade`;
      }
    },
  }
};
</script>

<style>
.checklist-form-edit-value {
  width: 300px;
}
</style>

<style>
.checklist-form-edit-add {
  margin-left: 81%;
  margin-top: 2%;
  width: 22%;
}
.add {
  margin-left: 81%;
  margin-top: 2%;
  width: 22%;
}

.campoAddCount,
.divAddNewFields,
.valor {
  margin-top: 2%;
}
</style>
